import { fetchSearchResultsSuccess } from 'store/search/searchActions';
import { getPageFromState } from './helpers';
import { getQueryParams } from 'store/router/routerSelectors';
import { createViewSearchResultsEvent } from '../eventCreators';
import { createViewSearchResultsEventPayload } from '../dataHelpers/createViewSearchResultsEventPayload';

const emitFetchSearchResultsSuccessEvent = (action, prevState) => {
  const meta = action.payload.meta;
  const page = getPageFromState(prevState);
  const queryParams = getQueryParams(prevState);

  const availablePropertyCount = meta?.counts?.filtered || 0;
  const totalPropertyCount = meta?.counts?.total || 0;

  const viewMode = page.name === 'QH Map Page' ? 'map' : 'list';
  const searchLocation = queryParams.location;

  const destinationType = searchLocation.includes('Australia') ? 'Domestic' : 'International';

  const viewSearchResultsEvent = createViewSearchResultsEvent(
    createViewSearchResultsEventPayload({
      availablePropertyCount,
      destinationDomesticType: null,
      destinationName: queryParams.location,
      destinationType,
      endDate: queryParams.checkOut,
      paymentType: queryParams.payWith,
      searchCategory: 'Hotels',
      searchTerm: queryParams.location,
      startDate: queryParams.checkIn,
      totalPropertyCount,
      viewMode,
      adults: Number(queryParams.adults),
      children: Number(queryParams.children),
      infants: Number(queryParams.infants),
    }),
  );

  return viewSearchResultsEvent;
};

export default { [fetchSearchResultsSuccess]: emitFetchSearchResultsSuccessEvent };
